export const SET_RESPONSIVE_DIALOG = "teamly/settings/SET_RESPONSIVE_DIALOG";

const initialState = {
    dialogOpen: false,
    dialogTitle: "Test",
    dialogMessage: "Message",
    positiveLabel: "Ok",
    negativeLabel: "Cancel",
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_RESPONSIVE_DIALOG:
            const {dialogOpen, dialogTitle, dialogMessage, positiveLabel, negativeLabel, dialogResponse} = action;
            return {
                ...state,
                dialogOpen,
                dialogTitle,
                dialogMessage,
                positiveLabel,
                negativeLabel,
                dialogResponse
            }
        default:
            return state;
    }
};

export const setResponsiveDialog = (
    dialogOpen,
    dialogTitle,
    dialogMessage,
    positiveLabel,
    negativeLabel,
    dialogResponse
) => ({
    type: SET_RESPONSIVE_DIALOG,
    dialogOpen,
    dialogTitle,
    dialogMessage,
    positiveLabel,
    negativeLabel,
    dialogResponse
});
